export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  WHATSAPP_CAMPAIGNS: 'whatsapp_campaign',
  WHATSAPP_EMBEDDED_SIGNUP_INBOX_CREATION:
    'whatsapp_embedded_signup_inbox_creation',
  WHATSAPP_MANUAL_TRANSFER: 'whatsapp_manual_transfer',
  WHATSAPP_RECONFIGURE: 'whatsapp_reconfigure',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  DATA_IMPORT: 'data_import',
  API_AND_WEBHOOKS: 'api_and_webhooks',
  BRANDED_EMAIL_TEMPLATES: 'branded_email_templates',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  EASYDESK_V4: 'easydesk_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CHANNEL_VOICE: 'channel_voice',
  CONTACT_EASYDESK_SUPPORT_TEAM: 'contact_easydesk_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_V1_ACTION_CLASSIFIER: 'captain_v1_action_classifier',
  CAPTAIN_V2: 'captain_integration_v2',
  CAPTAIN_V3: 'captain_v3',
  CAPTAIN_TASKS: 'captain_tasks',
  CAPTAIN_DOCUMENT_AUTO_SYNC: 'captain_document_auto_sync',
  HELP_CENTER_EMBEDDING_SEARCH: 'help_center_embedding_search',
  SAML: 'saml',
  COMPANIES: 'companies',
  ADVANCED_SEARCH: 'advanced_search',
  ADVANCED_SEARCH_INDEXING: 'advanced_search_indexing',
  CSAT_REVIEW_NOTES: 'csat_review_notes',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  UNREAD_COUNT_FOR_FILTERS: 'unread_count_for_filters',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.DISABLE_BRANDING,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.BRANDED_EMAIL_TEMPLATES,
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.HELP_CENTER_EMBEDDING_SEARCH,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.CAPTAIN_V1_ACTION_CLASSIFIER,
  FEATURE_FLAGS.CHANNEL_VOICE,
  FEATURE_FLAGS.CAPTAIN_V2,
  FEATURE_FLAGS.CAPTAIN_V3,
  FEATURE_FLAGS.CAPTAIN_DOCUMENT_AUTO_SYNC,
  FEATURE_FLAGS.ADVANCED_SEARCH,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.ADVANCED_SEARCH_INDEXING,
  FEATURE_FLAGS.COMPANIES,
  FEATURE_FLAGS.CSAT_REVIEW_NOTES,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
  FEATURE_FLAGS.API_AND_WEBHOOKS,
  FEATURE_FLAGS.WHATSAPP_RECONFIGURE,
  FEATURE_FLAGS.WHATSAPP_EMBEDDED_SIGNUP_INBOX_CREATION,
];
